import React from "react"
import injectSheet from "react-jss"
import { getProduct } from "@/helpers/products"
import { FencingTitle as RebrandingFencingTitle } from "@xingternal/rebranding-adapter"

const styles = {
  container: {
    composes: "flex align-items-center justify-content-end bold",
    color: ({ product }) => getProduct(product).color,
    "&:before": {
      content: '""',
      borderTop: "1px solid",
      flex: 1,
      order: ({ reversed }) => reversed && 1,
    },
  },
  child: {
    marginRight: ({ reversed }) => reversed && 4,
    marginLeft: ({ reversed }) => !reversed && 4,
  },
}

const FencingTitle = ({ preTitle, product, title, reversed }) => {
  const productIcon = {
    xtm: "xtm",
    xtp: "xtp",
    xjm: "xjm",
    xbm: "xbm",
    xbmUpsell: "xbm",
    360: "360",
    ebp: "xbm",
  }

  return (
    <RebrandingFencingTitle
      product={productIcon[product]}
      preTitle={preTitle}
      reversed={reversed}
      title={title || getProduct(product).license}
    />
  )
}

FencingTitle.defaultProps = {
  product: "xtm",
}

export const StyledFencingTitle = injectSheet(styles)(FencingTitle)
export default FencingTitle
